import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import Structure from "../../../common/components/builder/Structure.js";
import * as API from "../../lib/api.js";
import UploadBase64 from "../../lib/builder/base64.js";
import { GenerateDomain } from "../../lib/domain.js";
import * as Links from "../../lib/links.js";
import Wait from "../Wait";
import WizardFormNew from "../Wizard/WizardFormNew.jsx";

function CreateCustomStructure() {
    const structure = Structure();

    for (const child of structure.children) {
        if (child.name === "BlockHeader") {
            child.props.ProductType = "cross-platform";
        }

        if (child.name === "BlockOffers") {
            child.props = { BusinessGoal: "selling-plans" };
        }
    }

    return structure;
}

function InitialVariables() {
    return {
        Actions: [{ type: "offers", link: "#Offers" }],
        Disabled: {
            BlockHeader: {
                BGGradient: false,
            },
        },
    };
}

function InitialStructure() {
    return CreateCustomStructure();
}

export default function WebsiteNew(props) {
    const { t } = useTranslation();
    const history = useHistory();

    const refWebsiteNew = React.useRef(null);

    const [currentPart, setCurrentPart] = React.useState("");
    const [loading, setLoading] = React.useState(true);
    const [prevVariablesJSON, setPrevVariablesJSON] = React.useState(null);
    const [structure, setStructure] = React.useState(InitialStructure());
    const [variables, setVariables] = React.useState(InitialVariables());
    const [wait, setWait] = React.useState(false);

    const isTesting = useSelector(state => state.panel.account?.permissions?.testing);

    React.useEffect(() => {
        Load();
    }, []);

    React.useEffect(() => {
        Load();
    }, []);

    function Load() {
        setLoading(true);

        return API.WizardLoad()
            .then(({ partKey, variables, structure }) => {
                partKey && setCurrentPart(partKey);
                variables && setVariables(variables);
                structure && setStructure(structure);
                variables && setPrevVariablesJSON(JSON.stringify(variables));
            })
            .finally(() => {
                setLoading(false);
                setWait(false);
            });
    }

    // TODO: Almost a complete copy of Register.jsx
    function Save(publish = false, newSite = false, ignoreWait = false) {
        !ignoreWait && setWait(true);

        if (prevVariablesJSON !== JSON.stringify(variables)) {
            variables.dateModified = Date.now();
        }

        let Project = {
            id_project: null,
            domain: GenerateDomain(),
            variables,
        };

        let Page = { structure };

        const _state_ = (refWebsiteNew._state_ = refWebsiteNew._state_ || {});
        _state_.ProjectSetPromise = null;

        _state_.ProjectSetPromise = API.ProjectSet(Project)

            // * Error processing
            .then(res => {
                if (res?.errors) {
                    for (const error of res.errors) {
                        if (error?.error === "LIMIT_REACHED") {
                            toast.error(
                                t(
                                    variables?.ProductType === "ecommerce"
                                        ? "CurrentPlanDoesNotAllowYouToCreateECommerce"
                                        : "CurrentPlanDoesNotAllowYouToCreateWebsites"
                                ),
                                { autoClose: 30000 }
                            );

                            history.push(Links.Subscription());

                            throw { type: "abort" };
                        }

                        toast.error(error?.error || error, { autoClose: 30000 });
                    }

                    console.error(`[ERROR]`, res.errors);
                    throw new Error(`Errors above!`);
                }

                return res;
            })

            .then(res => (Project = { ...Project, ...res }))
            .then(() => variables.svgBg && API.SvgBgSign(variables.svgBg))
            .then(() => API.PageSet(Project.id_project, Page.structure))
            .then(res => (Page = { ...Page, ...res }))
            .then(() => UploadBase64({ id_project: Project.id_project, variables }))
            .then(() => API.ProjectUpdate(Project))
            .then(() => publish && API.CompileRender(Project.domain))
            .then(() => API.WizardClear())
            .then(() => true)

            .catch(e => {
                if (e?.type === "abort") {
                    return false;
                }

                toast.error(e.message);
                return false;
            })
            .then(success => {
                !ignoreWait && setWait(false);

                if (success) {
                    return newSite ? Links.WebsiteEditDesign(Project.id_project) : Links.Dashboard();
                } else {
                    return null;
                }
            });

        return _state_.ProjectSetPromise;
    }

    async function onCancelClick() {
        await API.WizardClear();
        history.goBack();
        return;
    }

    function onDesigningStart() {
        /* if (variables?.ProductType === "ecommerce") {
            return;
        }

        Save(true, true, true); */
    }

    function onDesigningEnd() {
        /* if (variables?.ProductType === "ecommerce") {
            return;
        }

        const _state_ = refWebsiteNew?._state_;

        if (!_state_?.ProjectSetPromise) {
            history.push(Links.Dashboard());
            return;
        }

        _state_.ProjectSetPromise.then(location => history.push(location)).finally(
            () => delete refWebsiteNew?._state_?.ProjectSetPromise
        ); */
    }

    function reset() {
        const variables = InitialVariables();
        const structure = InitialStructure();
        setVariables(variables);
        setStructure(structure);
        setPrevVariablesJSON(null);

        return { variables, structure };
    }

    const nestProps = {
        isTesting,
        currentPart,
        setCurrentPart,
        variables,
        setVariables,
        structure,
        setStructure,
        reset,

        onCancel: onCancelClick,
        Refresh: Load,
    };

    return (
        <div ref={refWebsiteNew} className="website-new">
            <WizardFormNew
                hide={props.preview || loading}
                onDesigningStart={onDesigningStart}
                onDesigningEnd={onDesigningEnd}
                dynamicDesigning={true}
                {...nestProps}
            />

            <Wait show={wait} />
        </div>
    );
}
